import styled from "styled-components";

export const OverlayWrapper = styled.span<{ $anchor: string }>`
  position: absolute;
  pointer-events: none;
  z-index: 10;
  max-width: calc(100% - 4px);
  line-height: 1;

  ${({ $anchor }) => $anchor === "top-left" && "top: 2px; left: 2px;"}
  ${({ $anchor }) => $anchor === "top-right" && "top: 2px; right: 2px;"}
  ${({ $anchor }) => $anchor === "bottom-left" && "bottom: 2px; left: 2px;"}
  ${({ $anchor }) => $anchor === "bottom-right" && "bottom: 2px; right: 2px;"}
  ${({ $anchor }) =>
    $anchor === "center" && "top: 50%; left: 50%; transform: translate(-50%, -50%);"}
  ${({ $anchor }) =>
    $anchor === "bottom-center" && "bottom: 2px; left: 50%; transform: translateX(-50%);"}
`;
